import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router';
import { PUBLIC_ROUTE } from '@router/route.constants';
import { LIMITS } from '@constants';
import { useSelector } from 'react-redux';
import { IMG_SPLASH_LOGO, IMG_SPLASH_BG } from '@assets';

const Container = styled.div`
    width: 100%;
    height: 100vh;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    background-image: url(${IMG_SPLASH_BG});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
`;

const LogoImg = styled.img.attrs({
    alt: 'logo',
    src: IMG_SPLASH_LOGO,
})`
max-width: 290px;
z-index: 2;
position: relative;

@media screen and (max-width: 375px) {
    max-width: 220px;
}
`;

const Splash = () => {
    const navigate = useNavigate();
    const { splash_ads_active } = useSelector(state => state.app.settings);
    let timer = useRef();

    useEffect(() => {
        timer.current = setTimeout(() => {
           goToNextScreen(splash_ads_active);
        }, LIMITS.SPLASH_SCREEN_TIMEOUT * 1000);

        return () => {
            clearTimeout(timer.current);
        }

        // eslint-disable-next-line
    }, [splash_ads_active]);

    const goToNextScreen = (splash_ads_active) => {
        if (splash_ads_active) {
            navigate(PUBLIC_ROUTE.ONBOARDING);
        }
        else {
            navigate(PUBLIC_ROUTE.LOGIN);
        }
    }

    return (
        <Container>
            <LogoImg />
        </Container>
    );
}

export default Splash;